import { render } from "./CDSDialog.vue?vue&type=template&id=f12c739a&ts=true"
import script from "./CDSDialog.vue?vue&type=script&lang=ts"
export * from "./CDSDialog.vue?vue&type=script&lang=ts"

import "./CDSDialog.vue?vue&type=style&index=0&id=f12c739a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__